/* eslint-disable */
import React from 'react';
import { Button, CheckboxGroup, Typography } from '@telus-uds/components-web';
import PropTypes from 'prop-types';
import { Formik, Form, Field } from 'formik';
import { getStepThreeSchema } from './schema';
import { useTranslationsContext } from '../context/TranslationsContext';

const StepThree = ({
  onSubmit,
  stepData: { productOfInterest, product, additionalComments },
  isSubmitting
}) => {
  const translations = useTranslationsContext();
  const {
    REFERRALS: {
      stepThree: { labels, errorLabels },
      modalData: { submit }
    }
  } = translations;
  const [wireline, wireless] = labels.productOfInterestOptions;
  const options = labels.productOptionsWireline.concat(
    labels.productOptionsWireless
  );
  const uniqueOptions = [...new Set(options)];

  // Product of Interest items
  const productOfInterestItems = [
    { label: wireline, id: wireline },
    { label: wireless, id: wireless }
  ];

  // Helper to get product items based on selection
  const getProductItems = (selectedInterests) => {
    if (!selectedInterests || selectedInterests.length === 0) {
      return [];
    }

    if (selectedInterests.length === 1) {
      if (selectedInterests[0] === wireline) {
        return labels.productOptionsWireline.map(option => ({
          label: option,
          id: option
        }));
      } else if (selectedInterests[0] === wireless) {
        return labels.productOptionsWireless.map(option => ({
          label: option,
          id: option
        }));
      }
    }

    // Both selected - show unique options
    if (selectedInterests.includes(wireline) && selectedInterests.includes(wireless)) {
      return uniqueOptions.map(option => ({
        label: option,
        id: option
      }));
    }

    return [];
  };

  return (
    <div className='layout-container'>
    <Formik
      validationSchema={getStepThreeSchema(errorLabels)}
      validateOnBlur={false}
      validateOnChange={false}
      onSubmit={onSubmit}
      initialValues={{
        productOfInterest: Array.isArray(productOfInterest) ? productOfInterest : (productOfInterest ? [productOfInterest] : []),
        product: Array.isArray(product) ? product : (product ? [product] : []),
        additionalComments: additionalComments || ''
      }}
    >
      {({ errors, touched, values, setFieldValue, handleSubmit }) => {
        // Convert productOfInterest to array if it's a string
        const productOfInterestValue = Array.isArray(values.productOfInterest)
          ? values.productOfInterest
          : (values.productOfInterest ? [values.productOfInterest] : []);

        // Convert product to array if it's a string
        const productValue = Array.isArray(values.product) ? values.product : (values.product ? [values.product] : []);

        // Get product items based on selection
        const productItems = getProductItems(productOfInterestValue);

        return (
          <Form>
            <div style={{ marginBottom: '20px', marginTop: '20px' }}>
              <div className="main-content-form-headers">
                <Typography block heading="h4" variant={{ size: 'h4' }}>{labels.productOfInterest}*</Typography>
              </div>
              <CheckboxGroup
                tokens={{ space: 0, fieldSpace: 0 }}
                legend={null}
                items={productOfInterestItems}
                checkedIds={productOfInterestValue}
                onChange={(checkedIds) => {
                  setFieldValue('productOfInterest', checkedIds);
                  // Clear product selection when productOfInterest changes
                  setFieldValue('product', []);
                }}
                name="productOfInterest"
                validation={errors.productOfInterest && touched.productOfInterest ? 'error' : undefined}
                feedback={errors.productOfInterest && touched.productOfInterest ? errors.productOfInterest : undefined}
              />
            </div>

            {productOfInterestValue.length > 0 && productItems.length > 0 && (
              <div style={{ marginBottom: '20px' }}>
                <div className="main-content-form-headers">
                  <Typography block heading="h4" variant={{ size: 'h4' }}>{labels.product}*</Typography>
                </div>
                <CheckboxGroup
                  tokens={{ space: 0, fieldSpace: 0 }}
                  legend={null}
                  items={productItems}
                  checkedIds={productValue}
                  onChange={(checkedIds) => {
                    setFieldValue('product', checkedIds);
                  }}
                  name="product"
                  validation={errors.product && touched.product ? 'error' : undefined}
                  feedback={errors.product && touched.product ? errors.product : undefined}
                />
              </div>
            )}
          <div className="main-content-form-headers">
            <Typography block heading="h4" variant={{ size: 'h4' }}>
              {labels.additionalComments}
            </Typography>
          </div>
          <div
            style={{ position: 'relative' }}
            className={`input-container ${
              errors.additionalComments && touched.additionalComments
                ? 'error'
                : ''
            }`}
          >
            <Field
              name="additionalComments"
              type="text"
              className="select-style"
              as="textarea"
              placeholder={labels.additionalComments}
            />
          </div>
            <div style={{ marginTop: '40px' }}>
              <Button variant={{ priority: 'high' }} type="button" onClick={handleSubmit}>
                {isSubmitting ? 'Submiting...' : submit}
              </Button>
            </div>
          </Form>
        );
      }}
    </Formik>
    </div>
  );
};

/* eslint-enable */
export default StepThree;
